import { create } from 'zustand';

import type { AppContext } from 'scbk-services/types/shared-context/app-context';

interface AppContextState {
    context: AppContext.Context;
    getAppContext: () => AppContext.Context;
    resetAppContext: () => void;
    setAppContext: (context: AppContext.Context) => void;
    updateAppContext: (header: AppContext.Context) => void;
}

const initialContext = {} as AppContext.Context;

const useAppContextStore = create<AppContextState>((set, get) => ({
    context: initialContext,
    getAppContext: () => get().context,
    resetAppContext: () => set({ context: {} }),
    setAppContext: (context: AppContext.Context) => set({ context: context }),
    updateAppContext: (context: AppContext.Context) =>
        set((state) => ({ context: { ...state.context, ...context } })),
}));

export { useAppContextStore };
